import axios from 'axios';
import {
  SCHEDULE_LIST_SCHEDULE_BEGIN,
  SCHEDULE_LIST_SCHEDULE_SUCCESS,
  SCHEDULE_LIST_SCHEDULE_FAILURE,
  SCHEDULE_LIST_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function listSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_LIST_SCHEDULE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/`;
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_LIST_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_LIST_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissListScheduleError() {
  return {
    type: SCHEDULE_LIST_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_LIST_SCHEDULE_BEGIN:
      return {
        ...state,
        listSchedulePending: true,
        listScheduleError: null,
      };

    case SCHEDULE_LIST_SCHEDULE_SUCCESS:
      return {
        ...state,
        listSchedulePending: false,
        listScheduleError: null,
        tasks: action.data.schedules,
      };

    case SCHEDULE_LIST_SCHEDULE_FAILURE:
      return {
        ...state,
        listSchedulePending: false,
        listScheduleError: action.data.error,
      };

    case SCHEDULE_LIST_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        listScheduleError: null,
      };

    default:
      return state;
  }
}
